(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var PaymentPanel = /*#__PURE__*/function () {
  function PaymentPanel() {
    _classCallCheck(this, PaymentPanel);

    this._lang = 'en_GB';
    this._logRef = '';
  }

  _createClass(PaymentPanel, [{
    key: "lang",
    set: function set(lang) {
      this._lang = lang;
    }
  }, {
    key: "domref",
    set: function set(domref) {
      this._domref = domref;
    }
  }, {
    key: "host",
    get: function get() {
      return this._host;
    },
    set: function set(host) {
      this._host = host;
    }
  }, {
    key: "basketID",
    set: function set(basketID) {
      this._basketID = basketID;
    }
  }, {
    key: "logRef",
    get: function get() {
      return this._logRef;
    }
  }, {
    key: "targetEnv",
    set: function set(targetEnv) {
      this._targetEnv = targetEnv;
    }
  }, {
    key: "errorHandler",
    set: function set(callback) {
      if (typeof callback === 'function') this._errorHandler = callback;
    }
  }, {
    key: "successHandler",
    set: function set(callback) {
      if (typeof callback === 'function') this._successHandler = callback;
    }
  }, {
    key: "bind",
    value: function bind(iframe) {
      this._targetFrame = iframe;
      this._host = "https://transact" + this._targetEnv + ".hotelmap.com";

      this._targetFrame.setAttribute('src', this._host + '/roomcard/payment.php?basketID=' + this._basketID + '&langCode=' + this._lang + '&domref=' + this._domref);
    }
  }, {
    key: "setParam",
    value: function setParam(name, value) {
      this.sendMsg('param', {
        name: value
      });
    }
  }, {
    key: "checkForm",
    value: function checkForm(highlight) {
      this.sendMsg(highlight ? 'check_form_highlight' : 'check_form');
    }
  }, {
    key: "submitForm",
    value: function submitForm() {
      // If we don't hear back from the transact server within a minute, force an error message
      var msg = {
        'type': 'trans_error',
        'data': {
          'error': 'ERR_TRANSACT_TIMEOUT'
        }
      };
      this._timeoutAlert = setTimeout(function () {
        RoomCardPaymentPanel.handleMsg(msg);
      }, 60000);
      this.sendMsg('buy');
    }
  }, {
    key: "handleMsg",
    value: function handleMsg(msg) {
      if (this._timeoutAlert) {
        clearTimeout(this._timeoutAlert);
        this._timeoutAlert = null;
      }

      var msgParts = msg.split('~~');
      if (msgParts.length == 3) this._logRef = msgParts[2];
      if (msgParts[0] === 'false' && typeof this._errorHandler === 'function') this._errorHandler(msgParts[1]);else if (msgParts[0] === 'true' && typeof this._successHandler === 'function') this._successHandler(msgParts[1]);
    }
  }, {
    key: "sendMsg",
    value: function sendMsg(type) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var msgContent = {
        '_is_hm': true,
        'type': type,
        'data': data
      };

      this._targetFrame.contentWindow.postMessage(msgContent, this._host);
    }
  }]);

  return PaymentPanel;
}();

exports["default"] = PaymentPanel;

},{}],2:[function(require,module,exports){
"use strict";

var _PaymentPanel = _interopRequireDefault(require("./classes/PaymentPanel"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

window.RoomCardPaymentPanel = new _PaymentPanel["default"]();
document.addEventListener('DOMContentLoaded', function () {
  window.addEventListener('message', function (event) {
    return messageHandler(event);
  }, false);
});

function messageHandler(event) {
  if (event.origin !== RoomCardPaymentPanel.host) return;
  var key = event.message ? "message" : "data";
  var data = event[key];
  if (typeof data !== 'string') return;
  RoomCardPaymentPanel.handleMsg(data);
}

},{"./classes/PaymentPanel":1}]},{},[2]);
